import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

export const getButtonIconUrl = type => {
  if (type === 'messages') return getStaticImage('/icons/orange-brand/icon-chat-primary-dark.svg')
  if (type === 'people') return getStaticImage('/icons/orange-brand/icon-user-slim-primary-dark.svg')
  if (type === 'files') return getStaticImage('/icons/orange-brand/icon-file-primary-dark.svg')
  if (type === 'chatmail') return getStaticImage('/icons/orange-brand/icon-at-sign-primary-dark.svg')
  if (type === 'campaigns') return getStaticImage('/icons/orange-brand/icon-campaign-primary-dark.svg')
  if (type === 'smartchat') return getStaticImage('/icons/orange-brand/icon-automation-primary-dark.svg')
}

export const getButtonValue = type => {
  if (type === 'messages') return lang('dashboard_messages')
  if (type === 'people') return lang('dashboard_people')
  if (type === 'files') return lang('dashboard_files')
  if (type === 'chatmail') return 'ChatMail'
  if (type === 'campaigns') return lang('dashboard_campaigns')
  if (type === 'smartchat') return lang('dashboard_smartchat')
}
